// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_W6svU {
  padding: 0px;
  width: 100%;
  /* max-width: 800px; */
  margin: 0 auto;
}

.permissionSection_fC18X {
  text-align: center;
  padding: 40px;
  background: var(--f5-background);
  border-radius: 10px;
  margin: 20px 0;
}

.permissionButton_co1LI {
  background: var(--4CAF50-background);
  color: var(--white-background);
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.permissionButton_co1LI:hover {
  background: var(--45a049-background);
}

.notificationGrid_qYQmN {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.demoButton_q7yoG {
  background: var(--white-background);
  border: 1px solid var(--dddddd-border);
  border-radius: 8px;
  padding: 20px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}


.demoButton_q7yoG:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--black-12901-shadow);
}

.demoButton_q7yoG:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.demoIcon_rn5UM {
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
}

.demoButton_q7yoG h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.demoButton_q7yoG p {
  margin: 0;
  font-size: 14px;
  color: var(--_6-color);
}





.panel_MR5AG {
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  .lastSignIn_KeOO_ {
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid var(--92959865-color);
    padding-bottom: 10px;

    b {
      font-size: 16px;
      font-weight: 500;
      color: var(--black-color);
    }

    p {
      font-size: 14px;
      color: var(--_6-color);
      margin: 0px;
    }
  }

  .totalActiveSessions_KxwFm {
    .totalActiveSessionsTitle_dyNQv {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .totalActiveSessionsCount_p5nEU {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    .totalActiveSessionsList_y9Atz {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      padding-left: 0px;
      margin: 0px;

      .totalActiveSessionsItem_XPCgm {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        border-bottom: 1px solid var(--92959865-color);
        /* padding-bottom: 10px; */
        padding: 10px 0px;

        .totalActiveSessionsItemIcon_fQ6sD {
          display: flex;
          flex-direction: column;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          background: var(--11a38138-border);
          border-radius: 6px;

          svg {
            width: 22px;
            height: 22px;
            color: var(--black-color);
          }
        }

        .totalActiveSessionsItemInfo_lDoGA {
          display: flex;
          flex-direction: column;
          gap: 4px;

          .totalActiveSessionsItemInfoTitle_c56lN {
            display: flex;
            align-items: center;
            gap: 4px;

            b {
              font-size: 16px;
              font-weight: 500;
              color: var(--black-color);
            }

            label {
              width: 6px;
              height: 6px;
              background: var(--_6-color);
              border-radius: 50%;
              margin: 0px;
            }

            p {
              margin: 0px;
              font-size: 16px;
              font-weight: 500;
              color: var(--black-color);
            }
          }

          .totalActiveSessionsItemInfoBrowser_wwWjs {
            display: flex;
            align-items: center;
            gap: 4px;

            b {
              font-size: 14px;
              color: var(--_6-color);
              margin: 0px;
              font-weight: 400;
            }

            label {
              width: 4px;
              height: 4px;
              background: var(--_6-color);
              border-radius: 50%;
              margin: 0px;
            }

            p {
              font-size: 14px;
              color: var(--_6-color);
              margin: 0px;
            }
          }

        }

        .totalActiveSessionsItemVerify_obCWW {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: auto;
          

          svg {
            width: 22px;
            height: 22px;
            color: var(--00a3a3-color);
          }
        }
      }
    }
  }

  .totalActiveSessionsButtons_hXP0t {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .totalActiveSessionsButtonsCloseAll_t7cWj {
      display: flex;
      /* flex-direction: column; */
      gap: 10px;

      button {
        width: 100%;
        padding: 4px 10px;
        background: #66666666;
        color: var(--white-color);
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 16px;
        transition: background 0.3s;
        white-space: nowrap;


        &.totalActiveSessionsButtonsClose_5JLll {
          width: 100%;
          padding: 10px;
          background: #B30634;
        }
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/Device/Device.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;;;;;AAMA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8CAA8C;IAC9C,oBAAoB;;IAEpB;MACE,eAAe;MACf,gBAAgB;MAChB,yBAAyB;IAC3B;;IAEA;MACE,eAAe;MACf,sBAAsB;MACtB,WAAW;IACb;EACF;;EAEA;IACE;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;;MAEnB;QACE,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,eAAe;;QAEf;UACE,WAAW;UACX,YAAY;QACd;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,WAAW;MACX,iBAAiB;MACjB,WAAW;;MAEX;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX,8CAA8C;QAC9C,0BAA0B;QAC1B,iBAAiB;;QAEjB;UACE,aAAa;UACb,sBAAsB;UACtB,WAAW;UACX,YAAY;UACZ,mBAAmB;UACnB,uBAAuB;UACvB,kCAAkC;UAClC,kBAAkB;;UAElB;YACE,WAAW;YACX,YAAY;YACZ,yBAAyB;UAC3B;QACF;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,QAAQ;;UAER;YACE,aAAa;YACb,mBAAmB;YACnB,QAAQ;;YAER;cACE,eAAe;cACf,gBAAgB;cAChB,yBAAyB;YAC3B;;YAEA;cACE,UAAU;cACV,WAAW;cACX,2BAA2B;cAC3B,kBAAkB;cAClB,WAAW;YACb;;YAEA;cACE,WAAW;cACX,eAAe;cACf,gBAAgB;cAChB,yBAAyB;YAC3B;UACF;;UAEA;YACE,aAAa;YACb,mBAAmB;YACnB,QAAQ;;YAER;cACE,eAAe;cACf,sBAAsB;cACtB,WAAW;cACX,gBAAgB;YAClB;;YAEA;cACE,UAAU;cACV,WAAW;cACX,2BAA2B;cAC3B,kBAAkB;cAClB,WAAW;YACb;;YAEA;cACE,eAAe;cACf,sBAAsB;cACtB,WAAW;YACb;UACF;;QAEF;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,iBAAiB;;;UAGjB;YACE,WAAW;YACX,YAAY;YACZ,0BAA0B;UAC5B;QACF;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;;IAEnB;MACE,aAAa;MACb,4BAA4B;MAC5B,SAAS;;MAET;QACE,WAAW;QACX,iBAAiB;QACjB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,2BAA2B;QAC3B,mBAAmB;;;QAGnB;UACE,WAAW;UACX,aAAa;UACb,mBAAmB;QACrB;MACF;IACF;EACF;AACF","sourcesContent":[".container {\n  padding: 0px;\n  width: 100%;\n  /* max-width: 800px; */\n  margin: 0 auto;\n}\n\n.permissionSection {\n  text-align: center;\n  padding: 40px;\n  background: var(--f5-background);\n  border-radius: 10px;\n  margin: 20px 0;\n}\n\n.permissionButton {\n  background: var(--4CAF50-background);\n  color: var(--white-background);\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.permissionButton:hover {\n  background: var(--45a049-background);\n}\n\n.notificationGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.demoButton {\n  background: var(--white-background);\n  border: 1px solid var(--dddddd-border);\n  border-radius: 8px;\n  padding: 20px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n\n.demoButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px var(--black-12901-shadow);\n}\n\n.demoButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.demoIcon {\n  width: 32px;\n  height: 32px;\n  margin-bottom: 10px;\n}\n\n.demoButton h3 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.demoButton p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--_6-color);\n}\n\n\n\n\n\n.panel {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  .lastSignIn {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    border-bottom: 1px solid var(--92959865-color);\n    padding-bottom: 10px;\n\n    b {\n      font-size: 16px;\n      font-weight: 500;\n      color: var(--black-color);\n    }\n\n    p {\n      font-size: 14px;\n      color: var(--_6-color);\n      margin: 0px;\n    }\n  }\n\n  .totalActiveSessions {\n    .totalActiveSessionsTitle {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .totalActiveSessionsCount {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        cursor: pointer;\n\n        svg {\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n\n    .totalActiveSessionsList {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      width: 100%;\n      padding-left: 0px;\n      margin: 0px;\n\n      .totalActiveSessionsItem {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        width: 100%;\n        border-bottom: 1px solid var(--92959865-color);\n        /* padding-bottom: 10px; */\n        padding: 10px 0px;\n\n        .totalActiveSessionsItemIcon {\n          display: flex;\n          flex-direction: column;\n          width: 40px;\n          height: 40px;\n          align-items: center;\n          justify-content: center;\n          background: var(--11a38138-border);\n          border-radius: 6px;\n\n          svg {\n            width: 22px;\n            height: 22px;\n            color: var(--black-color);\n          }\n        }\n\n        .totalActiveSessionsItemInfo {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n\n          .totalActiveSessionsItemInfoTitle {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            b {\n              font-size: 16px;\n              font-weight: 500;\n              color: var(--black-color);\n            }\n\n            label {\n              width: 6px;\n              height: 6px;\n              background: var(--_6-color);\n              border-radius: 50%;\n              margin: 0px;\n            }\n\n            p {\n              margin: 0px;\n              font-size: 16px;\n              font-weight: 500;\n              color: var(--black-color);\n            }\n          }\n\n          .totalActiveSessionsItemInfoBrowser {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            b {\n              font-size: 14px;\n              color: var(--_6-color);\n              margin: 0px;\n              font-weight: 400;\n            }\n\n            label {\n              width: 4px;\n              height: 4px;\n              background: var(--_6-color);\n              border-radius: 50%;\n              margin: 0px;\n            }\n\n            p {\n              font-size: 14px;\n              color: var(--_6-color);\n              margin: 0px;\n            }\n          }\n\n        }\n\n        .totalActiveSessionsItemVerify {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-left: auto;\n          \n\n          svg {\n            width: 22px;\n            height: 22px;\n            color: var(--00a3a3-color);\n          }\n        }\n      }\n    }\n  }\n\n  .totalActiveSessionsButtons {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    .totalActiveSessionsButtonsCloseAll {\n      display: flex;\n      /* flex-direction: column; */\n      gap: 10px;\n\n      button {\n        width: 100%;\n        padding: 4px 10px;\n        background: #66666666;\n        color: var(--white-color);\n        border: none;\n        border-radius: 6px;\n        cursor: pointer;\n        font-size: 16px;\n        transition: background 0.3s;\n        white-space: nowrap;\n\n\n        &.totalActiveSessionsButtonsClose {\n          width: 100%;\n          padding: 10px;\n          background: #B30634;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_W6svU`,
	"permissionSection": `permissionSection_fC18X`,
	"permissionButton": `permissionButton_co1LI`,
	"notificationGrid": `notificationGrid_qYQmN`,
	"demoButton": `demoButton_q7yoG`,
	"demoIcon": `demoIcon_rn5UM`,
	"panel": `panel_MR5AG`,
	"lastSignIn": `lastSignIn_KeOO_`,
	"totalActiveSessions": `totalActiveSessions_KxwFm`,
	"totalActiveSessionsTitle": `totalActiveSessionsTitle_dyNQv`,
	"totalActiveSessionsCount": `totalActiveSessionsCount_p5nEU`,
	"totalActiveSessionsList": `totalActiveSessionsList_y9Atz`,
	"totalActiveSessionsItem": `totalActiveSessionsItem_XPCgm`,
	"totalActiveSessionsItemIcon": `totalActiveSessionsItemIcon_fQ6sD`,
	"totalActiveSessionsItemInfo": `totalActiveSessionsItemInfo_lDoGA`,
	"totalActiveSessionsItemInfoTitle": `totalActiveSessionsItemInfoTitle_c56lN`,
	"totalActiveSessionsItemInfoBrowser": `totalActiveSessionsItemInfoBrowser_wwWjs`,
	"totalActiveSessionsItemVerify": `totalActiveSessionsItemVerify_obCWW`,
	"totalActiveSessionsButtons": `totalActiveSessionsButtons_hXP0t`,
	"totalActiveSessionsButtonsCloseAll": `totalActiveSessionsButtonsCloseAll_t7cWj`,
	"totalActiveSessionsButtonsClose": `totalActiveSessionsButtonsClose_5JLll`
};
export default ___CSS_LOADER_EXPORT___;
